import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Modal } from "@/components/common/Modal";
import { ADDITIONAL_WORKS_QUOTE_TYPE } from "@/utils/quoteHelpers";
import styles from "./EstimatingFilterModal.module.css";
const STATUS_OPTIONS = [
    { value: "draft", label: "Requested" },
    { value: "inprogress", label: "In Progress" },
    { value: "pending", label: "Pending Approval" },
    { value: "approved", label: "Approved" },
    { value: "declined", label: "Declined" },
    { value: "cancelled", label: "Cancelled" },
];
const QUOTE_TYPE_OPTIONS = [{ value: ADDITIONAL_WORKS_QUOTE_TYPE, label: "Additional Works" }];
export const EstimatingFilterModal = ({ isOpen, onClose, filterType, currentValue, onApply, }) => {
    const [selectedValue, setSelectedValue] = useState(currentValue);
    useEffect(() => {
        if (isOpen) {
            setSelectedValue(currentValue);
        }
    }, [isOpen, currentValue]);
    const handleApply = () => {
        onApply(selectedValue);
        onClose();
    };
    const handleClear = () => {
        setSelectedValue("");
        onApply("");
        onClose();
    };
    const getTitle = () => filterType === "status" ? "Filter by Status" : "Filter by Quote Type";
    const getOptions = () => filterType === "status" ? STATUS_OPTIONS : QUOTE_TYPE_OPTIONS;
    return (_jsx(Modal, { isOpen: isOpen, onClose: onClose, title: getTitle(), children: _jsxs("div", { className: styles.container, children: [_jsxs("div", { className: styles.selectWrapper, children: [_jsx("label", { className: styles.label, children: filterType === "status" ? "Status" : "Quote Type" }), _jsxs("select", { className: styles.select, value: selectedValue, onChange: (e) => setSelectedValue(e.target.value), children: [_jsx("option", { value: "", children: "Select an option..." }), getOptions().map((opt) => (_jsx("option", { value: opt.value, children: opt.label }, opt.value)))] })] }), _jsxs("div", { className: styles.actions, children: [_jsx("button", { type: "button", className: styles.clearBtn, onClick: handleClear, children: "Clear Filter" }), _jsx("button", { type: "button", className: styles.applyBtn, onClick: handleApply, disabled: !selectedValue, children: "Apply Filter" })] })] }) }));
};
